import { render, staticRenderFns } from "./metaData.vue?vue&type=template&id=09d99965"
import script from "./metaData.vue?vue&type=script&lang=js"
export * from "./metaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports